// ui/landingPage/calibrationLogsTab/uiLandingPageCalibrationLogsTabState.js

export const CALIBRATION_LOG_BOOK_VIEWS = {
  TABLE: "TABLE",
  CREATE_FORM: "CREATE_FORM",
  BOOK_FORM: "BOOK_FORM",
};

export const calibrationLogsTabUIInitialState = {
  currentView: CALIBRATION_LOG_BOOK_VIEWS.TABLE,
  activeTab: "active", // 'active' | 'completed'
};
